import { useSearchStore } from '../../stores/search-store.js';
import { useBarClause } from '../../hooks/useBarClause.js';
import { useAdvancedSubmit } from '../../hooks/useAdvancedSubmit.js';

const inputClass =
  'bg-gray-800 border border-gray-700 rounded-lg px-2.5 py-1.5 text-xs text-gray-300 placeholder-gray-600 focus:outline-none focus:border-orange-500 transition-colors w-full';

export function OracleTextInput() {
  const oracleText = useSearchStore((s) => s.advancedFilters.oracleText);
  const setAdvancedFilter = useSearchStore((s) => s.setAdvancedFilter);
  const { writeClause } = useBarClause();
  const { submit } = useAdvancedSubmit();

  const syncToBar = (value: string) => {
    const v = value.trim();
    // Always remove existing o: clauses first
    writeClause('o:', null);
    if (!v) return;

    // If user provided multiple quoted terms like "draw" "card", write each as o: clause
    const quotedTerms = v.match(/"[^"]+"/g);
    if (quotedTerms && quotedTerms.length > 1) {
      const currentBar = useSearchStore.getState().userInput;
      const clauses = quotedTerms.map((t) => `o:${t}`).join(' ');
      useSearchStore.getState().setUserInput(currentBar ? `${currentBar} ${clauses}` : clauses);
      return;
    }

    // Single term — wrap in quotes if not already quoted
    const quoted = v.startsWith('"') && v.endsWith('"') ? v : `"${v}"`;
    writeClause('o:', quoted);
  };

  return (
    <div className="space-y-1">
      <label className="text-[10px] text-gray-500 uppercase tracking-wider">Oracle Text</label>
      <input
        type="text"
        value={oracleText}
        onChange={(e) => setAdvancedFilter('oracleText', e.target.value)}
        onBlur={() => syncToBar(oracleText)}
        onKeyDown={(e) => { if (e.key === 'Enter') { syncToBar(oracleText); submit(); } }}
        placeholder='e.g. draw a card'
        className={inputClass}
      />
    </div>
  );
}
